import React, { useState, useEffect } from "react";
import { Moon, Sun, Music, User, Sliders, Loader2 } from "lucide-react";
import UsersAPI from "../services/usersApi";

export default function Settings() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = async () => {
    try {
      const response = await UsersAPI.getUserDetails();
      if (response.success) {
        setUser(response.data);
      }
    } catch (err) {
      console.error('Error fetching user:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-950 flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-pink-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-950 text-white relative overflow-hidden">
      {/* Animated Gradient Orbs */}
      <div className="absolute -top-20  -left-20 w-72 h-72 bg-pink-600/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-600/30 rounded-full blur-3xl animate-ping"></div>

      <div className="relative max-w-5xl mx-auto p-8 space-y-10 z-10">

        {/* Profile Section */}
        <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-5 hover:shadow-pink-500/30 transition-all">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <User className="w-6 h-6 text-pink-400" /> Profile
          </h2>
          <div className="flex gap-6 items-center">
            <img
              src={user?.avatar || "https://i.pravatar.cc/100"}
              alt="avatar"
              className="w-20 h-20 rounded-full border-4 border-pink-500 shadow-lg"
            />
            <div>
              <p className="text-xl font-semibold">{user?.name || user?.mobile || "User"}</p>
              <p className="text-gray-400 text-sm">{user?.email || "No email"}</p>
            </div>
          </div>
        </div>

        {/* Preferences */}
        <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-6 hover:shadow-purple-500/30 transition-all">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <Sliders className="w-6 h-6 text-pink-400" /> Preferences
          </h2>

          {/* Theme Toggle */}
          <div className="flex items-center justify-between">
            <p className="text-lg">Dark Mode</p>
            <div className="flex items-center gap-2">
              <Sun className="w-5 h-5 text-yellow-400" />
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" defaultChecked />
                <div className="w-14 h-7 bg-gray-700 rounded-full peer peer-checked:bg-gradient-to-r peer-checked:from-pink-500 peer-checked:to-purple-600 transition-all">
                  <div className="absolute left-1 top-1 bg-white w-5 h-5 rounded-full transition-all peer-checked:translate-x-7"></div>
                </div>
              </label>
              <Moon className="w-5 h-5 text-gray-300" />
            </div>
          </div>

          {/* Notifications */}
          <div className="flex items-center justify-between">
            <p className="text-lg">Notifications</p>
            <label className="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" className="sr-only peer" />
              <div className="w-14 h-7 bg-gray-700 rounded-full peer peer-checked:bg-gradient-to-r peer-checked:from-pink-500 peer-checked:to-purple-600 transition-all">
                <div className="absolute left-1 top-1 bg-white w-5 h-5 rounded-full transition-all peer-checked:translate-x-7"></div>
              </div>
            </label>
          </div>
        </div>

        {/* Audio Settings */}
        <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-6 hover:shadow-pink-500/30 transition-all">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <Music className="w-6 h-6 text-pink-400" /> Audio Settings
          </h2>
          <div className="space-y-6">
            <div>
              <label className="block text-sm text-gray-400 mb-2">Volume</label>
              <input type="range" className="w-full accent-pink-500 cursor-pointer" />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Bass Boost</label>
              <input type="range" className="w-full accent-purple-500 cursor-pointer" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
